import React, { memo } from 'react';
import styled from 'styled-components';

/**
 * Единственная область живого объявления на экране (ТЗ 0070).
 *
 * 🔴 Область ОДНА и стоит ВНЕ трансформируемого SVG. Две вежливые области
 * перебивают друг друга: скринридер читает одну, обрывает на середине и
 * начинает вторую — то есть студент не слышит ни одной целиком.
 *
 * Объявляем три вещи, и все три — смена того, что человек не видит:
 * выбранный узел, число найденного и число показанного после смены глубины.
 */
export const SkillMapAnnouncer = memo(({ message }: { message: string }) => (
  <Live role="status" aria-live="polite" aria-atomic="true">
    {message}
  </Live>
));

const Live = styled.p`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
`;
